export default __webpack_public_path__ + "static/media/home.70a58e48.mp4";